import ebook from 'marketing-website/media/images/pages/workshop/booklet-01@2x.png';
import second from 'marketing-website/media/images/pages/workshop/booklet-02@2x.png';

const assets = {
  hero: {
    alt: 'WorkBook',
    src: ebook,
    hasShadow: false,
  },
  second: {
    alt: 'WorkBook for Enterprise',
    src: second,
    hasShadow: false,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/workshop/workshop.js